import React from 'react';
import './ActionDropdownMenu.scss';
import useAuthUtilities from '../../../../AuthMiddleware/AuthUtilities';
import { ProjectDto } from '../../../../data/models/projectsService';
import { ActionMenuItem } from './ActionMenuItem';
import { ActionMenuActions } from './ActionDropdownMenu';

interface AddToProjectMenuItemProps {
  project?: ProjectDto;
  onAddToProject: () => void;
  onRemoveFromProject: () => void;
}

export default function AddToProjectMenuItem(props: AddToProjectMenuItemProps) {
  const { canUserWriteProjectService } = useAuthUtilities();
  const addToProject = !props.project;

  if (!canUserWriteProjectService()) {
    return null;
  }

  return (
    <>
      {addToProject ? (
        <ActionMenuItem
          action={ActionMenuActions.AddToProject}
          disabled={false}
          onClickHandler={
            addToProject ? props.onAddToProject : props.onRemoveFromProject
          }
        ></ActionMenuItem>
      ) : (
        <ActionMenuItem
          action={ActionMenuActions.RemoveFromProject}
          disabled={false}
          onClickHandler={
            addToProject ? props.onAddToProject : props.onRemoveFromProject
          }
        ></ActionMenuItem>
      )}
    </>
  );
}
